export default String.raw`
{% assign isDiscount = true -%}
{% if order.Discount == 0 or settings.discountsPresentationOnOrderPositions <> 'yes' -%}
    {% assign isDiscount = false -%}
{% endif -%}

<div class="eshop__table-container products">
    <table class="products-table-js">
    {% if page.QueryString contains 'tab=inquiry-details' -%}
        <colgroup>
            <col style="width:10px">
            <col style="width:400px">
            <col style="width:1000px">
        </colgroup>
    {% endif -%}
    {% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' -%}
        {% assign order = customer-profile.Order -%}
    {% elseif page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' -%}
        {% assign order = customer-profile.Offer -%}
        {% assign isDiscount = false -%}
    {% endif -%}

    {% include 'partials/order/products-partials/product-table-header.html' -%}

    {% assign wasParent = null -%}

    {% assign productsList = order.Products -%}
    {% assign productsOnPage = 100 -%}

    {% if order.OrderStep == 'Start' -%}
        {% assign pageNumber = include -%}
        {% assign startingProductIndex = pageNumber | Times:productsOnPage | Minus:productsOnPage  -%}
        {% assign productsList = productsList | Skip:startingProductIndex | Take:productsOnPage -%}
    {% endif -%}

    {% assign isSetElement = false -%}
    {% for product in productsList -%}
        {% assign nextIndex = forloop.index -%}
        {% assign nextEl = order.Products[nextIndex] -%}
        {% if product.IsSetElement -%}
            {% assign isSetElement = true -%}
        {% endif -%}
        {% if product.IsSetParent -%}
            {% assign wasParent = true -%}
            <tr class="set-row" data-product-no="{{ product.No }}">
                {% include 'partials/order/products-partials/set-aggregator.html' with product.No -%}
        {% endif -%}
        {% if product.IsSetElement and wasParent and (nextEl == null or nextEl.IsSetElement == false or nextEl.IsSetParent) -%}
            </tr>
            {% assign wasParent = false -%}
        {% endif -%}
        <tr class="row expandable-mechanism-container-js {% if product.IsSetElement -%} set set-element-js {% endif -%}" data-product-no="{{product.No}}" data-product-id="{{product.Id}}" data-product-price="{% if config.ENTERPRISE -%}{{product.TotalPrice}}{% else -%}{{product.Price}}{% endif -%}">
            {% include 'partials/product/products-table.html' with product.No -%}
        </tr>
    {% endfor -%}
    {% if order.OrderStep == 'Start' -%}
        {% assign productsSize = order.Products | Size -%}
        {% assign paginationPageCount = productsSize | DividedBy:productsOnPage -%}
        {% assign productsModulo = productsSize | Modulo:productsOnPage -%}

        {% if productsModulo != 0 -%}
            {% assign paginationPageCount = paginationPageCount | Plus:1 -%}
        {% endif -%}
    {% endif -%}
    {% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' or page.QueryString contains 'orderHash' -%}
        {% assign paginationPageCount = customer-profile.Order.PageCount -%}
    {% elseif page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' -%}
        {% assign paginationPageCount = customer-profile.Offer.PageCount -%}
    {% endif -%}
        <tr class="summary-row">
            <td {% if page.PageId == config.DefinedPages.Order.Id -%} class="open-delete-cart-confirmation-js" {% endif -%} {% if page.PageId == config.DefinedPages.Order.Id -%} style="color: #696666; cursor: pointer;" {% endif -%}>
                {% if page.PageId == config.DefinedPages.Order.Id -%}
                    {% if page.QueryString contains 'inquiry=true' -%}
                        {{translations.DeleteInquiry}} (
                    {% else -%}
                        {{translations.DeleteCart}} (
                    {% endif -%}
                {% else -%}
                    {{translations.ItemsQuantity}}:
                {% endif -%}
                {% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' -%}
                    {{customer-profile.Order.TotalItems}}
                {% elseif page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' -%}
                    {{customer-profile.Offer.TotalItems}}
                {% else -%}
                    {{order.Products | Size}}
                {% endif -%}
                {% if page.PageId == config.DefinedPages.Order.Id -%}
                    )
                {% endif -%}
            </td>

            {% if page.QueryString contains 'tab=offer-details' -%}
                {% assign DepositValue = order.DepositValue -%}
            {% else -%}
                {% assign DepositValue = order.TotalDepositValue -%}
            {% endif -%}

            {% unless page.QueryString contains 'tab=inquiry-details' -%}
                {% if isDiscount -%}
                    <td></td>
                {% endif -%}
                <td></td>
                <td></td>
                {% if DepositValue > 0 -%}
                    <td></td>
                {% endif -%}
                <td></td>
                <td></td>
                <td class="prices-view-js">
                    <span>
                    {% if config.ENTERPRISE -%}
                        {% if page.QueryString contains 'tab=offer-details' -%}
                            {{order.SubtotalValue | ToPrice}}
                        {% else -%}
                            {{order.ProductsSubtotalValue | ToPrice}}
                        {% endif -%}
                    {% else -%}
                        <span>{{ translations.Brutto | Downcase }}</span> {{order.ProductsValue | ToPrice}}
                    {% endif -%}
                    </span>
                </td>
            {% endunless -%}

            {% if config.ENTERPRISE -%}
                <td class="prices-view-js">
                {% unless page.QueryString contains 'tab=inquiry-details' -%}      
                    {% if page.QueryString contains 'tab=offer-details' -%}
                        {{order.TotalValue | ToPrice}}
                    {% else -%}
                        {{order.ProductsTotalValue | ToPrice}}
                    {% endif -%}
                {% endunless -%}
                </td>
            {% endif -%}
            <td class="prices-view-js">
            {% unless page.QueryString contains 'tab=inquiry-details' -%}
                {{order.CurrencyExt}}
            {% endunless -%}
            </td>
            <td></td>
            <td></td>
        </tr>
    </table>
</div>
{% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' or page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' or page.QueryString contains 'orderHash'-%}
    <div>
        {% include 'partials/common/pagination.html' -%}
    </div>
{% endif -%}
{% assign productsQuantity = order.Products | Size -%}
{% assign showLoader = false -%}
{% unless order.OrderStep == 'Start' and productsQuantity <= 20 -%}
    {% assign showLoader = true -%}
{% endunless -%}
{% if order.OrderStep == 'Start' and isSetElement -%}
    {% assign showLoader = true -%}
{% endif -%}

{% if showLoader -%}
<div class="during-ajax-modal-js during-ajax-modal hidden-js">
    <div class="loader big"></div>
</div>
{% endif -%}

{% if order.Status == 3 and order.OneTimeOffer == false -%}
    {% assign canProduceMultipleTimes = true -%}
{% endif -%}
{% if order.Status == 2 or canProduceMultipleTimes -%}
    {% assign goodStatus = true -%}
{% endif -%}
`